import { render } from "./offRoom.vue?vue&type=template&id=5bf777dd"
import script from "./offRoom.vue?vue&type=script&lang=js"
export * from "./offRoom.vue?vue&type=script&lang=js"

import "./offRoom.vue?vue&type=style&index=0&id=5bf777dd&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__